import axios, { AxiosInstance } from "axios";
import { GetInstitutionalKYBResponse, UploadImageResponse } from "../models/models";
import { createApiInstance } from "./createAPIInstance";

class CommonServices {
  private api: AxiosInstance;

  constructor() {
    this.api = createApiInstance();
  }

 public async uploadImage(
  file: File,
  fileId: string | number
): Promise<UploadImageResponse> {
  if (fileId === undefined || fileId === null) {
    throw new Error("FileId parameter is required for unauthenticated uploads");
  }

  const formData = new FormData();
  formData.append("file", file);
  // Many backends accept/require it in the form body too:
  formData.append("fileId", String(fileId));

  const response = await this.api.post<UploadImageResponse>(
    "/common/openUploadFile",
    formData,
    {
      // Let the browser set the correct multipart boundary automatically
      // (uncomment only if your server insists on explicit header)
      // headers: { "Content-Type": "multipart/form-data" },
      // params: { fileId }, // results in ?imgId=123
    }
  );

  return response.data;
}


  /**
   * POST /user/saveInstitutionalKYB
   * Accepts any JSON payload. Optionally pass a generic type arg to type the response.
   * Example:
   *   const res = await commonServices.saveInstitutionalKYB<{ success: boolean; message: string; data: { id: number } }>(payload);
   */
  public async saveInstitutionalKYB<TResponse = any>(
    payload: Record<string, any>,
    isSubmitted: boolean,
    applicationid?: string
  ): Promise<TResponse> {
    try {
      const response = await this.api.post<TResponse>(
        "/user/saveSubmitInstitutionalKYB",
        { kyb_data: payload, is_submitted: isSubmitted, id: applicationid },
        { headers: { "Content-Type": "application/json" } }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async saveKybDataAdmin<SaveKybDataResponse>(
  payload: Record<string, any>,
  applicationid?: number | string,
  jwt?: string, // optional in case you reuse the method elsewhere
  isSubmitted: boolean = true
): Promise<SaveKybDataResponse> {
  try {
    const response = await axios.put<SaveKybDataResponse>(
      "https://api.tylt.money/adminPanel/updateKYBRecord",
      {
        kyb_data: payload,
        is_submitted: isSubmitted,
        id: applicationid,
      },
      {
        headers: {
          "Content-Type": "application/json",
          ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}), 
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

  public async getInstitutionalKYB(
    id: number | string
  ): Promise<GetInstitutionalKYBResponse> {
    try {
      const res = await this.api.get<GetInstitutionalKYBResponse>(
        `/user/getInstitutionalKYB/${encodeURIComponent(String(id))}`
      );
      return res.data;
    } catch (error) {
      // You can add centralized logging here if desired
      throw error;
    }
  }


}

export const commonServices = new CommonServices();
